<template>
    <div class="datanalyze">
        <div class="row">
            <mm-lc title="Time">
                <mm-date-range v-model="where.time" />
            </mm-lc>
            <mm-lc title="UTC+8">
                <el-switch v-model="utc_8"></el-switch>
            </mm-lc>
            <mm-lc title="Advertiser">
                <mm-adv-select v-model="where.adv_id" multiple />
            </mm-lc>
            <mm-lc title="Channel">
                <mm-channel-select v-model="where.networkid" multiple />
            </mm-lc>
            <mm-lc title="Offer Id">
                <mm-multi-input v-model="where.offerid" />
            </mm-lc>
			<mm-lc title="Country">
					<mm-offer-geos v-model="where.country" multiple />
			</mm-lc>
        </div>
        <div class="row flex-end">
            <mm-lc title="Campare By">
                <mm-campare-option v-model="campareBy" />
            </mm-lc>
            <mm-lc title="Campare Period">
                <mm-campare-period v-model="camparePeriod"/>
            </mm-lc>
            <mm-lc title="Top Counts">
                <mm-select v-model="topCounts" :clearable="false" :options="[5,6,7,8,9,10].map(v=>{return {label:v,value:v}})"/>
            </mm-lc>
            <el-button class="bt-apply" type="primary"   @click="refresh">apply</el-button>
			<el-button class="el-icon-tickets" type="info" @click="copy" />
        </div>
		<el-dialog :visible.sync="dialogTableVisible">
			<div slot="title">
			<span>{{datasetLabel}}</span>
			<el-button type="primary" @click="getClicks" style="margin-left:40px;">Get Clicks</el-button>

			</div>
			<mm-table :res="tableData">
				<el-table-column label="period" prop="period" />
				<el-table-column label="revenue" prop="revenue" />
				<el-table-column label="conv" prop="conv" />
				<el-table-column label="cost" prop="cost" />
				<el-table-column label="sent_conv" prop="sent_conv" />
				<el-table-column label="clicks" prop="clicks" />
				<el-table-column label="cvr" prop="cvr" />
			</mm-table>
		</el-dialog >
        <el-tabs class="chart" v-model="editableTabsValue" type="card" @tab-remove="removeTab" @tab-click="tabClick" >
            <el-tab-pane v-for="(item, index) in editableTabs" :closable="!item.fix" :key="index" :label="item.label" :name="item.name">
                <mm-pie-chart v-if="item.chartType==='pie'" :ref="'chart'+index" class="chart" :selectOne="selectOne"  />
                <mm-line-chart v-else :ref="'chart'+index" class="chart" :selectOne="selectOne" :showDataset="showDataset" />
            </el-tab-pane>
        </el-tabs>

    </div>
</template>

<script>
let tabIndex = 1;
const addTabConf = {name:'+1',label:'+',fix:true}
export default {
	data() {
		return {
			where: {
				adv_id: "",
				networkid: "",
				offerid: "",
				country:"",
			},
			tableData:{},
			datasetLabel:'',
			dialogTableVisible:false,
			requestBody:{},
			campareBy: "adv_id",
			topCounts:5,
			utc_8: false,
			camparePeriod: "daily",
			editableTabs:[{name:'0',label:'Total',fix:true,chartType:"line"},addTabConf],
			editableTabsValue:0,
		};
	},
	computed: {
		condition() {
			const where = JSON.parse(JSON.stringify(this.where));
			const condition = {};
			for (let [k, v] of Object.entries(where)) {
				if (!v && v !== 0) {
					continue;
				} else if (Array.isArray(v)) {
					if (v.length === 1) {
						condition[k] = v[0];
					} else if (v.length > 1) {
						condition[k] = { $in: v };
					}
				} else {
					condition[k] = v;
				}
			}
			return condition;
		},
		title(){
			const groupMap = {
				adv_id:'Advervisr',
				networkid:'Channel',
				offerid:'Offer',
				country:'Country',
			}
			return groupMap[this.campareBy] || 'Total';
		},
       
	},
	methods: {
		
		async refresh(e) {
			const requestBody = {
				where: this.condition,
				campareBy: this.campareBy,
				camparePeriod: this.camparePeriod,
				topCounts: this.topCounts,
				utc_8: this.utc_8
			};
			const chartData = await this.$post("/datanalyze/list", requestBody)
			this._changeTabLabel();
			chartData.requestBody = JSON.parse(JSON.stringify(requestBody));
			this.editableTabs[this.editableTabsValue].chartType = this.camparePeriod?"line":"pie";
			// render after component amount
			await new Promise((res,rej)=>setTimeout(res,0));
			this.$refs['chart'+this.editableTabsValue][0].renderChart(chartData);
		},
		selectOne(campareBy,clickV) {
			if(typeof clickV ==='object'){
				this.where[campareBy] = clickV;
			}else if(clickV){
				this.where[campareBy] = {$in:[clickV]};
			}else{
				this.where[campareBy] = '';
			}
		},
		showDataset(dataset,labels,chartData){
			const rows = dataset.rows;
			this.tableData = {rows};
			this.datasetLabel = dataset.label;
			const requestBody = JSON.parse(JSON.stringify(chartData.requestBody));
			if(requestBody.campareBy){
				requestBody.where[requestBody.campareBy] = dataset.id;
			}
			this.requestBody = requestBody;
			this.dialogTableVisible = true;
		},
		_changeTabLabel(){
			const self = this;
			this.editableTabs.forEach(function(conf){
				if(conf.name===self.editableTabsValue){
					conf.label = self.title;
				}
			})
		},
		tabClick(tab){
			if(tab.name ==='+1'){
				this.addTab();
			}
		},
		addTab(type){
			const editV = ''+tabIndex++;
			this.editableTabs.splice(this.editableTabs.length-1,0,{name:editV,label:this.title,chartType:type});
			this.editableTabsValue = editV;
		},
		async getClicks(){
			const result = await this.$post('/datanalyze/getClicks',this.requestBody);
			const rows = this.tableData.rows.map(function(row){
				row.clicks = result[row.period]||0;
				row.cvr = row.conv/(row.clicks||1);
				row.cvr = (row.cvr * 100).toFixed(2) + '%;'
				return row;
			})
			this.tableData.rows = rows;
		},
		removeTab(targetName){
			{
				let tabs = this.editableTabs;
				let activeName = this.editableTabsValue;
				if (activeName === targetName) {
					tabs.forEach((tab, index) => {
						if (tab.name === targetName) {
							let nextTab = tabs[index + 1] || tabs[index - 1];
							if (nextTab) {
								activeName = nextTab.name;
							}
						}
					});
				}
          
				this.editableTabsValue = activeName;
				this.editableTabs = tabs.filter(tab => tab.name !== targetName);
			}
		},
		async copy(){
			try{
				let chartData = this.$refs['chart'+this.editableTabsValue][0].chartData;
				const labels = JSON.parse(JSON.stringify(chartData.labels));
				let datasets = chartData.datasets.map(v=>{return {data:v.data,label:v.label,rows:v.rows}});
				datasets = JSON.parse(JSON.stringify(datasets));
				let header = ['Date',chartData.campareBy,'Revenue','Conv','Cost','Sent_conv'];
				const data = [header];
				datasets.forEach(v=>{
					labels.forEach((label,i)=>{
						const row = v.rows[i];
						data.push([
							label,
							v.label,
							row['revenue'],
							row['conv'],
							row['cost'],
							row['sent_conv'],
						])
					})
				})
				const text = data.map(row=>row.join('	')).join('\n');
				await this.$copyText(text);
				this.$message({
					type:'success',
					message:'Copied successfully',
				})
			}catch(e){
				console.error(e);
			}
			
		},
	}
};
</script>

<style scoped>
.datanalyze {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
}
.row {
	width: 100%;
	display: flex;
	margin-bottom: 10px;
    
}
.flex-end{
    align-items: flex-end;
}
.bt-apply {
	height: 38px;
	width: 80px;
}
.chart {
	width: 1000px;
	height: 600px;
}
</style>
